import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customkeymap: {
      /**
       * Select text between node boundaries
       */
      selectTextWithinNodeBoundaries: () => ReturnType;
    };
  }
}

const CustomKeymap = Extension.create({
  name: 'CustomKeymap',

  addCommands() {
    return {
      selectTextWithinNodeBoundaries:
        () =>
        ({ editor, commands }) => {
          const { state } = editor;
          const { tr } = state;
          const startNodePos = tr.selection.$from.start();
          const endNodePos = tr.selection.$to.end();
          return commands.setTextSelection({
            from: startNodePos,
            to: endNodePos,
          });
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      // eslint-disable-next-line littlebird/naming-convention
      'Mod-a': ({ editor }) => {
        const { state } = editor;
        const { tr } = state;
        const startSelectionPos = tr.selection.from;
        const endSelectionPos = tr.selection.to;
        const startNodePos = tr.selection.$from.start();
        const endNodePos = tr.selection.$to.end();
        const isCurrentTextSelectionNotExtendedToNodeBoundaries =
          startSelectionPos > startNodePos || endSelectionPos < endNodePos;
        if (isCurrentTextSelectionNotExtendedToNodeBoundaries) {
          editor.chain().selectTextWithinNodeBoundaries().run();
          return true;
        }
        return false;
      },
      // eslint-disable-next-line littlebird/naming-convention
      'Mod-Shift-k': ({ editor }) => {
        const { from, to } = editor.state.selection;
        const text = editor.state.doc.textBetween(from, to);
        if (text) {
          editor.chain().focus().setLink({ href: '' }).run();
        }
        return true;
      },
      // eslint-disable-next-line littlebird/naming-convention
      'Mod-Shift-s': ({ editor }) => {
        editor.chain().focus().toggleStrike().run();
        return true;
      },
      // eslint-disable-next-line littlebird/naming-convention
      'Mod-Shift-c': ({ editor }) => {
        editor.chain().focus().toggleCode().run();
        return true;
      },
    };
  },
});

export default CustomKeymap;
